export const mockLicenseInfo = {
  DAQ: {
    description: 'License Number',
    content: 'ABC12345',
  },
  DCS: {
    description: 'Last Name',
    content: 'HAZEL',
  },
  DAC: {
    description: 'First Name',
    content: 'BILLY',
  },
  DAD: {
    description: 'Middle Name',
    content: 'RAY',
  },
  DCA: {
    description: 'Jurisdiction-specific vehicle class',
    content: 'C',
  },
  DBD: {
    description: 'Issue Date',
    content: '01262018',
  },
  DBB: {
    description: 'Birth Date',
    content: '07041978',
  },
  DBA: {
    description: 'Expiry Date',
    content: '07042022',
  },
  DBC: {
    description: 'Gender',
    content: 'Male',
  },
  DAU: {
    description: 'Height',
    content: '072 IN',
  },
  DAY: {
    description: 'Eye Color',
    content: 'BRO',
  },
  DAG: {
    description: 'Street',
    content: '3745 GARFIELD ST',
  },
  DAI: {
    description: 'City',
    content: 'CARLSBAD',
  },
  DAJ: {
    description: 'State',
    content: 'CA',
  },
  DAK: {
    description: 'Zip',
    content: '92008',
  },
  DCF: {
    description: 'Document Discriminator',
    content: '08/07/201567620/BBFD/22',
  },
  DCG: {
    description: 'Issue Country',
    content: 'USA',
  },
  DAW: {
    description: 'Weight(pounds)',
    content: '180',
  },
  DAZ: {
    description: 'Hair Color',
    content: 'BRO',
  },
  DCK: {
    description: 'Inventory Control Number',
    content: '18026F50364770401',
  },
  DDA: {
    description: 'Compliance Type',
    content: 'N',
  },
  DDB: {
    description: 'Card Revision Date',
    content: '08292017\rZCZCABRN',
  },
}
